(function(){
  // Read promo data from the Liquid-rendered JSON script tag
  var promoData = document.getElementById('czx-promo-data');
  var promos = [];
  if (promoData) { try { promos = JSON.parse(promoData.textContent); } catch(e) {} }
  /* No fallback — if all promos are blank, hide the banner entirely */
  if (promos.length === 0) {
    var banner = document.getElementById('crazxy-promo-banner');
    if (banner) banner.style.display = 'none';
    /* Also collapse the promo height variable so navbar sits at top:0 */
    document.documentElement.style.setProperty('--crazxy-promo-h', '0px');
    return;
  }

  var current  = 0;
  var total    = promos.length;
  var timer    = null;
  var interval = 5000;

  var elLabel    = document.getElementById('crazxy-promo-label');
  var elText     = document.getElementById('crazxy-promo-text');
  var elCta      = document.getElementById('crazxy-promo-cta');
  var elProgress = document.getElementById('crazxy-promo-progress');
  var elDots     = document.getElementById('crazxy-promo-dots');
  var elPrev     = document.getElementById('crazxy-promo-prev');
  var elNext     = document.getElementById('crazxy-promo-next');
  var elClose    = document.getElementById('crazxy-promo-close');
  var elBanner   = document.getElementById('crazxy-promo-banner');
  var elStage    = document.getElementById('crazxy-promo-stage');
  var elSizer    = document.getElementById('crazxy-promo-sizer');

  /* ── Measure all promos invisibly, lock banner to tallest height ── */
  function measureAndLockHeight() {
    if (!elSizer || !elStage) return;
    elSizer.innerHTML = '';
    elSizer.style.width = elStage.offsetWidth + 'px';

    promos.forEach(function(p) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:0.75rem;padding:0 1.25rem;width:100%;box-sizing:border-box;';
      var inner = document.createElement('div');
      var isMobile = window.innerWidth <= 749;
      inner.style.cssText = 'flex:1;display:flex;align-items:center;justify-content:center;gap:0.65rem;flex-wrap:' + (isMobile ? 'nowrap' : 'wrap') + ';padding:' + (isMobile ? '0.15rem' : '0.45rem') + ' 0;font-family:Boogaloo,cursive;';
      var lbl = document.createElement('span');
      lbl.style.cssText = 'font-size:0.75rem;padding:0.15rem 0.6rem;border-radius:2px;white-space:nowrap;flex-shrink:0;background:' + p.color + ';' + (isMobile ? 'display:none;' : '');
      lbl.textContent = p.label;
      var txt = document.createElement('span');
      txt.style.cssText = 'font-size:' + (isMobile ? '0.72rem' : '0.9rem') + ';font-weight:700;text-align:center;white-space:' + (isMobile ? 'nowrap' : 'normal') + ';';
      txt.textContent = p.text;
      inner.appendChild(lbl);
      inner.appendChild(txt);
      if (p.cta) {
        var btn = document.createElement('span');
        btn.style.cssText = 'font-size:0.8rem;padding:0.15rem 0.65rem;border-radius:2px;border:1px solid rgba(0,0,0,0.3);white-space:nowrap;flex-shrink:0;';
        btn.textContent = p.cta;
        inner.appendChild(btn);
      }
      row.appendChild(inner);
      elSizer.appendChild(row);
    });

    var maxH = 0;
    Array.from(elSizer.children).forEach(function(row) {
      maxH = Math.max(maxH, row.offsetHeight);
    });
    elSizer.innerHTML = '';

    /* Apply locked height to the flex row inside stage */
    var contentRow = elStage.querySelector('div');
    if (contentRow && maxH > 0) {
      contentRow.style.minHeight = maxH + 'px';
    }
  }

  /* Build dots */
  if (total > 1) {
    for (var d = 0; d < total; d++) {
      var dot = document.createElement('button');
      dot.setAttribute('aria-label', 'Promo ' + (d+1));
      dot.style.cssText = 'width:6px;height:6px;border-radius:50%;border:none;cursor:pointer;transition:all 0.2s;padding:0;background:rgba(255,255,255,0.25);';
      dot.dataset.index = d;
      dot.addEventListener('click', function(){ goTo(parseInt(this.dataset.index)); });
      elDots.appendChild(dot);
    }
  }

  function render(idx) {
    var p = promos[idx];
    elLabel.textContent = p.label;
    elLabel.style.background = p.color;
    elText.textContent  = p.text;
    if (p.cta && p.url) {
      elCta.textContent = p.cta;
      elCta.href = p.url;
      elCta.style.display = 'inline';
      elCta.style.borderColor = p.color;
    } else if (p.cta) {
      elCta.textContent = p.cta;
      elCta.removeAttribute('href');
      elCta.style.display = 'inline';
    } else {
      elCta.style.display = 'none';
    }
    var dots = elDots.querySelectorAll('button');
    dots.forEach(function(d, i){
      d.style.background = i === idx ? '#fff' : 'rgba(255,255,255,0.25)';
      d.style.width  = i === idx ? '16px' : '6px';
      d.style.borderRadius = '3px';
    });
    elProgress.style.transition = 'none';
    elProgress.style.width = '0%';
    elProgress.style.background = p.color;
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        elProgress.style.transition = 'width ' + (interval / 1000 - 0.1) + 's linear';
        elProgress.style.width = '100%';
      });
    });
  }

  function goTo(idx) {
    clearTimeout(timer);
    current = (idx + total) % total;
    render(current);
    if (total > 1) timer = setTimeout(function(){ goTo(current + 1); }, interval);
  }

  function maybeShowControls() {
    var w = window.innerWidth;
    if (total > 1) {
      elPrev.style.display = w >= 640 ? 'inline-block' : 'none';
      elNext.style.display = w >= 640 ? 'inline-block' : 'none';
      elDots.style.display = w >= 640 ? 'flex' : 'none';
    }
  }

  if (elPrev) elPrev.addEventListener('click', function(){ goTo(current - 1); });
  if (elNext) elNext.addEventListener('click', function(){ goTo(current + 1); });

  if (elClose) elClose.addEventListener('click', function(){
    elBanner.style.display = 'none';
    document.body.classList.add('crazxy-no-promo');
    clearTimeout(timer);
    var nav = document.getElementById('crazxy-navbar');
    var navH = nav ? nav.offsetHeight : 72;
    document.documentElement.style.setProperty('--crazxy-promo-h', '0px');
    document.documentElement.style.setProperty('--crazxy-nav-offset', navH + 'px');
    var drawer = document.getElementById('crazxy-mobile-drawer');
    if (drawer) drawer.style.top = navH + 'px';
  });

  function init() {
    maybeShowControls();
    measureAndLockHeight();
    goTo(0);
  }

  /* Wait for Boogaloo font before measuring so text wraps accurately */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  } else {
    window.addEventListener('load', init);
  }

  window.addEventListener('resize', function() {
    maybeShowControls();
    measureAndLockHeight();
  });
})();